import React from "react";

export const DynamicallyInsertHtml = ({ html }) => {
  return <div className="mx-auto w-full md:max-w-6xl text-base my-10 p-4 styleList text-justify" dangerouslySetInnerHTML={{ __html: html.trim() }}></div>;
};
